import { render, staticRenderFns } from "./DialogTimeoutDatiGrezzi.vue?vue&type=template&id=0330aa24&"
import script from "./DialogTimeoutDatiGrezzi.vue?vue&type=script&lang=js&"
export * from "./DialogTimeoutDatiGrezzi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports